/* eslint-disable */
import React, { Component } from "react";
import store from "./state/store";
import localStorageActions from "./common/helpers/localStorageActions";
import AddToast from "./state/actions/AddToast";
import Modal from "./components/atoms/Modal";
import { httpRequest } from "./services/http";

export default class FeedbackForm extends Component {
  constructor() {
    super();
    this.pendingRequest = null;
    this.state = {
      feedbackName: store.getState().userName,
      feedbackEmail: store.getState().userEmail,
      showFeedbackModal: false,
    };
  }

  componentWillMount() {
    this.mapStoreToState(store.getState());
    this.subscription = store.subscribe(() => {
      this.mapStoreToState(store.getState());
    });
  }

  componentWillUnmount() {
    this.subscription();
  }

  componentWillUpdate(nextProps, nextState) {
    if (
      nextState.multipleResults &&
      this.state.multipleResults !== nextState.multipleResults &&
      !nextState.error
    ) {
      let showFeedbackModal = false;
      let normalFeedback = false;
      // After some successful queries, show a feedback popup
      // Putting this here instead of Search.js to only have it on varsome site
      localStorageActions.increaseNumRequests();
      if (localStorageActions.shouldShowFeedbackPopup()) {
        showFeedbackModal = true;
        normalFeedback = true;
      }
      setTimeout(() => {
        this.setState({ showFeedbackModal, normalFeedback });
      }, 3000);
    }
  }

  postFeedback(e) {
    e.preventDefault();
    let url = "/feedback/";
    httpRequest
      .post(
        url,
        {
          "feedback-name": this.state.feedbackName,
          "feedback-email": this.state.feedbackEmail,
          "feedback-message": this.state.feedbackMessage,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        }
      )
      .then((response) => {
        this.setState({
          showFeedbackModal: false,
        });
        AddToast("Thank you for your feedback", "success");
      })
      .catch((error) => {
        console.error("While posting feedback:", error);
      });
  }

  handleFeedbackInputChange(stateKey, event) {
    const stateObj = {};
    stateObj[stateKey] = event.target.value;
    this.setState(stateObj);
  }

  mapStoreToState(storeState) {
    this.setState({
      multipleResults: storeState.multipleResults,
      showFeedbackModal: storeState.showFeedbackModal,
      error: storeState.error,
    });
  }

  hideFeedbackModal() {
    store.dispatch({
      type: "SHOW_FEEDBACK_MODAL",
      showFeedbackModal: false,
    });
  }

  render() {
    return (
      <Modal
        isOpen={this.state.showFeedbackModal}
        onRequestClose={this.hideFeedbackModal.bind(this)}
        ContentRender={() => {
          return (
            <div className="tw-p-6">
              {this.state.normalFeedback ? (
                <h4>Please tell us what you think about VarSome</h4>
              ) : (
                <h4>Contact us</h4>
              )}
              <div className="tw-mt-4">
                <form
                  id="feedback-form"
                  onSubmit={this.postFeedback.bind(this)}
                >
                  {this.state.normalFeedback ? (
                    <p className="card-text">
                      What do you like the most? What do you wish it did/didn't
                      do? Anything you don't like?
                      <br />
                      We won't know until you tell us!
                    </p>
                  ) : (
                    <p />
                  )}
                  <fieldset className="form-group">
                    <div className="row">
                      <div className="col-lg-6">
                        <input
                          className="form-control"
                          type="text"
                          name="feedback_name"
                          value={this.state.feedbackName}
                          onChange={this.handleFeedbackInputChange.bind(
                            this,
                            "feedbackName"
                          )}
                          placeholder="Your name"
                        />
                      </div>
                      <div className="col-lg-6">
                        <input
                          className="form-control"
                          type="email"
                          name="feedback_email"
                          value={this.state.feedbackEmail}
                          onChange={this.handleFeedbackInputChange.bind(
                            this,
                            "feedbackEmail"
                          )}
                          placeholder="Your email"
                        />
                      </div>
                    </div>
                    <br />

                    <textarea
                      className="form-control"
                      name="feedback_message"
                      required={true}
                      value={this.state.feedbackMessage}
                      onChange={this.handleFeedbackInputChange.bind(
                        this,
                        "feedbackMessage"
                      )}
                      placeholder="Your comments"
                      rows="5"
                    />
                    <div id="feedback-message-errors" />
                  </fieldset>
                  <div className="varsome-text-center">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          );
        }}
      />
    );
  }
}
